import { dependencies } from '@pn/core/dependencies';
import type { ExtraCompanyInfo } from '@pn/core/domain/intel/intel';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { companyExtraInfoSlice } from './companyExtraInfoSlice';

export const useExtraCompanyInfoStorage = () => {
  const { name, getInitialState } = companyExtraInfoSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isFetching: useSliceSelector((state) => state.isFetching),
    isError: useSliceSelector((state) => state.isError),
    company: useSliceSelector((state) => state.company),
  };
};
export const extraCompanyInfoActions = () => {
  const { dispatch, getState } = dependencies.store;
  const { actions, name } = companyExtraInfoSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    request: () => dispatch(actions.request()),
    receive: (company: ExtraCompanyInfo) => dispatch(actions.receive(company)),
    error: () => dispatch(actions.error()),
    reset: () => dispatch(actions.reset()),
  };
};
